import { render, staticRenderFns } from "./CapturaHuella.vue?vue&type=template&id=0b4089f4&scoped=true"
import script from "./CapturaHuella.vue?vue&type=script&lang=js"
export * from "./CapturaHuella.vue?vue&type=script&lang=js"
import style0 from "./CapturaHuella.vue?vue&type=style&index=0&id=0b4089f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4089f4",
  null
  
)

export default component.exports